<div class="message-container" [ngClass]="{ 'current-user': currentUser }">
  <!-- INDIVIDUAL MESSAGE -->
  <app-message
    [showIcon]="false"
    [currentUser]="currentUser"
    [messageContent]="message.content"
    [user]="user?.fullName ?? '-'"
  ></app-message>
  <div class="time-stamp">
    <p>
      {{ message.sentTime ?? "" | date }}
    </p>
  </div>
</div>
